<template>
  <a-drawer
    width="50%"
    :label-col="4"
    :wrapper-col="14"
    :visible="open"
    @cancel="onClose"
    @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :label-col="labelCol" :wrapper-col="wrapperCol" :model="form" :rules="rules">
      <a-form-model-item :label="$t('问题分类')" prop="problemTypeId" >
        <a-select :placeholder="$t('请选择')+$t('问题分类')" v-model="form.problemTypeId" allowClear>
          <a-select-option
            v-for="(item, index) in helpTypeList"
            :value="item.id"
            :key="index">
            {{ item.title }}
          </a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item :label="$t('常见问题标题')" prop="title" >
        <a-input v-model="form.title" :maxLength="32" :placeholder="$t('请输入')+$t('常见问题标题')" >
          <locale-field-button
            slot="suffix"
            class="ant-input-suffix-button"
            v-model="form.localeFieldMap['title']"
            input-type="input"
            table-name="help_problem"
            table-field="title"
            :field-value="form.title"/>
        </a-input>
      </a-form-model-item>

      <a-form-model-item :label="$t('显示顺序')" prop="orderSort" >
        <a-input-number style="width: 100%" v-model="form.orderSort" :maxLength="32" @change="limitSort" :placeholder="$t('请输入')+$t('显示顺序')" />
      </a-form-model-item>
      <a-form-model-item :label="$t('状态')" prop="status" >
        <a-radio-group v-model="form.status" button-style="solid">
          <a-radio-button v-for="(item, index) in this.customDict.StatusEnum" :value="item.type" :key="index">
            {{ item.name }}
          </a-radio-button>
        </a-radio-group>
      </a-form-model-item>
      <a-form-model-item :label="$t('是否最热')" prop="isHot" >
        <a-radio-group v-model="form.isHot" button-style="solid">
          <a-radio-button v-for="(item, index) in this.customDict.TFEnum" :value="item.type" :key="index">
            {{ item.name }}
          </a-radio-button>
        </a-radio-group>
      </a-form-model-item>
      <a-form-model-item :label="$t('常见问题简述')" prop="sketch" >
        <a-input v-model="form.sketch" :maxLength="32" :placeholder="$t('请输入')+$t('常见问题简述')" />
      </a-form-model-item>
      <a-form-model-item :label="$t('常见问题内容')" prop="contentInfo" >
        <editor v-model="form.contentInfo" :placeholder="$t('请输入')"/>
      </a-form-model-item>
      <a-modal :visible="previewImageVisible" :footer="null" @cancel="previewImageCancel">
        <img alt="example" style="width: 100%" :src="previewUrl" />
      </a-modal>
      <a-modal :visible="previewVideoVisible" :footer="null" @cancel="previewVideoCancel">
        <video
          style="width: 100%"
          :src="previewUrl"
          ref="myVideo"
          :poster="previewUrl + '?x-oss-process=video/snapshot,t_0,f_jpg'"
          :controls="true"></video>
      </a-modal>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            {{ $t('保存') }}
          </a-button>
          <a-button type="dashed" @click="cancel">
            {{ $t('取消') }}
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { getProblem, addProblem, updateProblem } from '@/api/help/problem'
import { mapGetters } from 'vuex'
import CustomDictTag from '@/components/DictCustomTag'
import { listType } from '@/api/help/type'
import Editor from '@/components/Editor/Editor'
import LocaleFieldButton from "@/components/locale/LocaleFieldButton.vue";

export default {
  name: 'CreateForm',
  props: {
  },
  components: {
    LocaleFieldButton,
    CustomDictTag,
    Editor

  },
  data () {
    return {
      helpTypeList: [],
      labelCol: { span: 4 },
      wrapperCol: { span: 14 },
      submitLoading: false,
      formTitle: '',
      previewImageVisible: false,
      previewUrl: '',
      previewVideoVisible: false,
      loading: '',
      // 表单参数
      form: {
        id: null,
        type: 1,
        problemTypeId: null,

        title: null,

        sketch: null,

        contentInfo: null,

        orderSort: null,

        status: 0,

        isHot: false,

        remark: null,
        localeFieldMap: {},

        createTime: null

      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
        problemTypeId: [
          { required: true, message: this.$t('问题分类') + this.$t('不能为空'), trigger: 'change' }
        ],
        title: [
          { required: true, message: this.$t('常见问题标题') + this.$t('不能为空'), trigger: 'blur' }
        ],
        sketch: [
          { required: true, message: this.$t('常见问题简述') + this.$t('不能为空'), trigger: 'blur' }
        ],
        contentInfo: [
          { required: true, message: this.$t('常见问题内容') + this.$t('不能为空'), trigger: 'blur' }
        ]
      }
    }
  },
  filters: {
  },
  created () {
    this.getHelpTypeList()
  },
  computed: {
    ...mapGetters(['customDict'])
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    onClose () {
      this.open = false
      this.reset()
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    previewImageCancel() {
      this.previewImageVisible = false
    },
    previewVideoCancel() {
      this.previewVideoVisible = false
    },
    getHelpTypeList () {
      listType({"type":1}).then(response => {
        this.helpTypeList = response.data
      })
    },
    // 表单重置
    reset () {
      this.formType = 1
      this.form = {
        id: null,
        type: 1,
        problemTypeId: null,
        title: null,
        sketch: null,
        contentInfo: null,
        orderSort: null,
        status: 0,
        isHot: false,
        remark: null,
        localeFieldMap: {},
        createTime: null
      }
    },
    limitSort(sort) {
      let val = sort
      if (val == null || val == undefined || val == '' || val < 0) {
        val = 0
      }
      if (val > 999999) {
        val = 999999
      }
      this.form.orderSort = val
    },
    /** 新增按钮操作 */
    handleAdd (row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = this.$t('添加')
    },
    /** 修改按钮操作 */
    handleUpdate (row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getProblem({ 'id': id }).then(response => {
        this.form = response.data
        this.open = true
        this.formTitle = this.$t('修改')
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          let message = ''
          if (this.form.id !== undefined && this.form.id !== null) {
            message = this.$t('修改成功')
            updateProblem(this.form).then(response => {
              this.$message.success(
                message,
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            message = this.$t('修改成功')
            addProblem(this.form).then(response => {
              this.$message.success(
                message,
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>
